import { DOMReadyP, ScrollBlockers } from '@app-helpers'
import {
    allConsentLevelsAreSetInCookies,
    rejectAllConsentLevels,
    rejectConsentLevel,
    setAllConsentLevels,
    setConsentLevel,
} from './cookie-modal.storage'
import { stringToAvgConsentLevel } from '@app-enums'

DOMReadyP.then(() => {
    const cookieModal = document.getElementById('cookie-modal');

    if (! cookieModal) return

    const acceptButton = cookieModal.querySelector('#cookie-modal--accept')

    if (acceptButton && acceptButton instanceof HTMLElement) {
        handleAcceptButton(cookieModal, acceptButton)
    }

    const rejectButton = cookieModal.querySelector('#cookie-modal--reject')

    if (rejectButton && rejectButton instanceof HTMLElement) {
        handleRejectButton(cookieModal, rejectButton)
    }

    const detailsButton = cookieModal.querySelector('#cookie-modal--details')

    if (detailsButton && detailsButton instanceof HTMLElement) {
        handleDetailsButton(cookieModal, detailsButton)
    }

    const cookieSettings = cookieModal.querySelectorAll('.cookie-modal__details-list-element-details')

    cookieSettings.forEach(setting => {
        if (setting instanceof HTMLDetailsElement) handleSingleCookieSetting(setting)
    })

    const allowSelectionButton = cookieModal.querySelector('#cookie-modal--allow-selection')

    if (allowSelectionButton && allowSelectionButton instanceof HTMLElement) {
        handleAllowSelectionButton(cookieModal, allowSelectionButton, cookieSettings)
    }

    if (! allConsentLevelsAreSetInCookies()) {
        cookieModal.classList.remove('hidden')
    }
})

function handleAcceptButton(modal: HTMLElement, acceptButton: HTMLElement) {
    acceptButton.addEventListener('click', () => {
        setAllConsentLevels()
        modal.classList.add('hidden')
        ScrollBlockers.remove('article-preview')
    })
}

function handleRejectButton(modal: HTMLElement, rejectButton: HTMLElement) {
    rejectButton.addEventListener('click', () => {
        rejectAllConsentLevels()
        modal.classList.add('hidden')
        ScrollBlockers.remove('article-preview')
    })
}

function handleDetailsButton(modal: HTMLElement, detailsButton: HTMLElement) {
    detailsButton.addEventListener('click', () => {
        ScrollBlockers.toggle('article-preview')
        modal.classList.toggle('cookie-modal--show-details')

        if (modal.classList.contains('cookie-modal--show-details') && detailsButton.dataset.closeText) {
            detailsButton.innerHTML = detailsButton.dataset.closeText

            return
        }

        if (! modal.classList.contains('cookie-modal--show-details') && detailsButton.dataset.openText) {
            detailsButton.innerHTML = detailsButton.dataset.openText
        }
    })
}

function handleSingleCookieSetting(setting: HTMLDetailsElement) {
    const cookieConsent = setting.dataset.cookieConsent

    if (! cookieConsent) return

    const summary = setting.querySelector('.cookie-modal__details-list-element-summary')
    const detailButton = setting.querySelector('.cookie-modal__details-list-element-button')
    const toggle = setting.querySelector('.cookie-modal__toggle-container')

    if (summary && summary instanceof HTMLElement) {
        summary.addEventListener('click', (event) => {
            event.preventDefault()
        })
    }

    if (detailButton && detailButton instanceof HTMLElement) {
        detailButton.addEventListener('click', () => {
            setting.open = ! setting.open

            if (setting.open && detailButton.dataset.closeText) {
                detailButton.innerHTML = detailButton.dataset.closeText

                return
            }

            if (! setting.open && detailButton.dataset.openText) {
                detailButton.innerHTML = detailButton.dataset.openText
            }
        })
    }

    if (toggle && toggle instanceof HTMLElement && cookieConsent !== 'necessary') {
        toggle.addEventListener('click', () => {
            setting.classList.toggle('active')
        })
    }
}

function handleAllowSelectionButton(
    modal: HTMLElement,
    allowSelectionButton: HTMLElement,
    cookieSettings: NodeListOf<Element>,
) {
    allowSelectionButton.addEventListener('click', () => {
        let acceptedConsents: string[] = []
        let rejectedConsents: string[] = []

        cookieSettings.forEach(setting => {
            if (! (setting instanceof HTMLElement)) return

            if (setting.classList.contains('active') && setting.dataset.cookieConsent) acceptedConsents.push(setting.dataset.cookieConsent)
            if (! setting.classList.contains('active') && setting.dataset.cookieConsent) rejectedConsents.push(setting.dataset.cookieConsent)
        })

        acceptedConsents.forEach(consent => {
            const avgConsentLevel = stringToAvgConsentLevel(consent)

            if (avgConsentLevel) setConsentLevel(avgConsentLevel)
        })

        rejectedConsents.forEach(consent => {
            const avgConsentLevel = stringToAvgConsentLevel(consent)

            if (avgConsentLevel) rejectConsentLevel(avgConsentLevel)
        })

        modal.classList.add('hidden')
        ScrollBlockers.remove('article-preview')
    })
}